<template>
  <MarketInsightsPage
    v-slot="{ slug, categoriesArticles, playVideo }"
    :market="market"
  >
    <NuxtPage
      :slug="slug"
      :categories-articles="categoriesArticles"
      :categories-videos="categoriesArticles"
      @play-video="playVideo"
    />
  </MarketInsightsPage>
</template>

<script setup lang="ts">
import MarketInsightsPage from '~/components/market/MarketInsightsPage.vue'
import { PHOSPHATE, MARKET } from '~/constants/services/constants'

const market = {
  ...PHOSPHATE,
  hideAnalysis: true,
}

const { getSeoInfo } = useSeo()

const seo = getSeoInfo({
  title: `${MARKET.name}: ${PHOSPHATE.name} Market Insights`,
})
useHead(seo)

definePageMeta({ layout: 'services' })
</script>
